import { render, staticRenderFns } from "./MyApplications.vue?vue&type=template&id=6701b438&scoped=true"
import script from "./MyApplications.vue?vue&type=script&lang=js"
export * from "./MyApplications.vue?vue&type=script&lang=js"
import style0 from "./MyApplications.vue?vue&type=style&index=0&id=6701b438&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6701b438",
  null
  
)

export default component.exports